import { queryCache } from 'react-query';
import { QueryKeys } from '~src/hooks/api-hooks/queryKeys';
import { loadTenderShareCoreRegistration } from '~src/services/api/shares';
import { DbShareTender } from '~src/types/db';

export const getShareDataWithCacheKey = async (
  shareId?: string,
  shareKey?: string | null
) => {
  const cachedSharesParams = [
    QueryKeys.sharedTender,
    { id: shareId, key: shareKey },
  ];

  const cachedQuery = queryCache.getQueryData<DbShareTender>(
    cachedSharesParams
  );

  if (cachedQuery) return cachedQuery;

  const cachedShareTenderData = await loadTenderShareCoreRegistration(null, {
    id: shareId || '',
    key: shareKey || '',
  });

  queryCache.setQueryData(cachedSharesParams, cachedShareTenderData);

  return cachedShareTenderData;
};
